import React from "react"
import {
  FaFacebookSquare,
  FaLinkedin,
  FaDribbbleSquare,
  FaBehanceSquare,
  FaGithubSquare,
  FaTwitterSquare,
  
} from "react-icons/fa"

const data = [
  {
    id: 1,
    icon: <FaGithubSquare  className="social-icon"></FaGithubSquare>,
    url: "https://github.com/GithakaMbui",
  },
  {
    id: 2,
    icon: <FaLinkedin className="social-icon"></FaLinkedin>,
    url: "https://www.linkedin.com/in/githaka-mbui",
  },
  {
    id: 3,
    icon: <FaTwitterSquare className="social-icon"></FaTwitterSquare>,
    url: "https://twitter.com/MbuiCodes",
    
  },
  // {
  //   id: 4,
  //   icon: <FaDribbbleSquare className="social-icon"></FaDribbbleSquare>,
  //   url: "#",
  // },
  // {
  //   id: 5,
  //   icon: <FaBehanceSquare className="social-icon"></FaBehanceSquare>,
  //   url: "#",
  // },
]
const links = data.map(link => {
  return (
    <li key={link.id}>
      <a href={link.url} className="social-link">
        {link.icon}
      </a>
    </li>
  )
})

export default ({ styleClass }) => {
  return (
    <ul className={`social-links ${styleClass ? styleClass : ""}`}>{links}</ul>
  )
}
